export type State = {
	sideNavOpened: boolean;
}

export function createState({
	  sideNavOpened = false}: Partial<State>) {
	return {
		sideNavOpened,
	}
}